export default "__VITE_ASSET__Bw8hgd9Z__"